import { configureStore } from '@reduxjs/toolkit';
import todoReducer from './slices/imageSlice';
import portifolioReducer from './slices/portifolioSlice'

export default configureStore({
  reducer: {
    images: todoReducer,
    portifolio:portifolioReducer
  },
});